export default "__VITE_ASSET__Bx72ViXR__"